/**
 * Qobuz Connect route (Paul GO Oct 27 2026): the Connector drives ANY player that
 * advertises Qobuz Connect through Qobuz Connect when its normal network path is down
 * or held. Routing lives in the Connector (capability, never brand/model); the web
 * only labels those zones and shows the Connector's plain notices verbatim.
 */

/** Connector `transport_type` for a player reachable only through Qobuz Connect. */
export const QOBUZ_CONNECT_TRANSPORT = 'qobuz-connect';

/** Brand name — shown as-is in every language. */
export const QOBUZ_CONNECT_LABEL = 'Qobuz Connect';

/** Start of the Connector's notice when a local file is sent to a Connect-only player. */
export const QOBUZ_CONNECT_ONLY_PREFIX = 'This player is reachable only through Qobuz Connect';

type ZoneLike = { metadata?: Record<string, unknown> | null; transport_type?: string | null } | null | undefined;

export function isQobuzConnectZone(zone: ZoneLike): boolean {
  const t = (zone?.metadata?.transport_type ?? zone?.transport_type ?? '') as string;
  return t === QOBUZ_CONNECT_TRANSPORT;
}

export function isQobuzConnectNotice(errMsg: string | null | undefined): boolean {
  return typeof errMsg === 'string' && errMsg.startsWith(QOBUZ_CONNECT_ONLY_PREFIX);
}
